import classNames from 'classnames';
import { forwardRef, HTMLProps, VFC } from 'react';

import styles from './CustomButton.module.scss';

export type ButtonVariant =
  | 'primary'
  | 'primaryOutlined'
  | 'secondary'
  | 'darkOutlined'
  | 'whiteShadow'
  | 'dark'
  | 'whiteOrange';

type Props = HTMLProps<HTMLButtonElement> & {
  type?: 'submit' | 'button';
  variant?: ButtonVariant;
  loading?: boolean;
};

const CustomButton: VFC<Props> = forwardRef(
  (
    {
      type = 'button',
      variant = 'primary',
      disabled = false,
      loading = false,
      className,
      children,
      ...restProps
    }: Props,
    ref
  ) => {
    const classes = classNames(
      [styles.customButton, styles[variant], { [styles.loading]: loading }],
      className
    );

    return (
      <button
        type={type}
        className={classes}
        disabled={disabled || loading}
        {...restProps}
        ref={ref}
      >
        {children}
      </button>
    );
  }
);

export default CustomButton;
